'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BinaryInterpreter2 = require('./BinaryInterpreter');

var _BinaryInterpreter3 = _interopRequireDefault(_BinaryInterpreter2);

var _jsdk = require('jsdk');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author Bruno bruno.camargos@gmail.com
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @date 2016/01/18
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/** 0-15 to ASCII hex digit lookup table. */
var HEX_ASCII = [0x30, 0x31, 0x32, 0x33, 0x34, 0x35, 0x36, 0x37, 0x38, 0x39, 0x41, 0x42, 0x43, 0x44, 0x45, 0x46];

var AsciiHexInterpreter = function (_BinaryInterpreter) {
    _inherits(AsciiHexInterpreter, _BinaryInterpreter);

    function AsciiHexInterpreter() {
        _classCallCheck(this, AsciiHexInterpreter);

        return _possibleConstructorReturn(this, (AsciiHexInterpreter.__proto__ || Object.getPrototypeOf(AsciiHexInterpreter)).apply(this, arguments));
    }

    _createClass(AsciiHexInterpreter, [{
        key: 'interpret',
        value: function interpret(data, b, offset) {
            for (var i = 0; i < data.length; i++) {
                b[offset + i * 2] = HEX_ASCII[(data[i] & 0xF0) >> 4];
                // b[offset + i * 2] = ((data[i] & 0xF0) >> 4).toString(16).charCodeAt(0); /*it works too, but in lowercase*/
                b[offset + i * 2 + 1] = HEX_ASCII[data[i] & 0x0F];
                // b[offset + i * 2 + 1] = (data[i] & 0x0F).toString(16).charCodeAt(0); /*it works too, but in lowercase*/
            }
        }
    }, {
        key: 'uninterpret',
        value: function uninterpret(rawData, offset, length) {
            var d = new Array(length);
            for (var i = 0; i < length * 2; i++) {
                var shift = i % 2 === 1 ? 0 : 4;
                d[i >> 1] |= parseInt(String.fromCharCode(rawData[offset + i]), 16) << shift;
            }
            return d;
        }
    }, {
        key: 'getPackedLength',
        value: function getPackedLength(nBytes) {
            return nBytes * 2;
        }
    }]);

    return AsciiHexInterpreter;
}(_BinaryInterpreter3.default);

exports.default = new AsciiHexInterpreter();


//////////////////
// WEBPACK FOOTER
// ./node_modules/jspos/lib/AsciiHexInterpreter.js
// module id = 31
// module chunks = 0